import React from 'react'
import { ManageState } from './manageState'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout';
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../../routes/routeName';
import TableCustom from '../../../../components/table/tableCustom';
import StateComponents from '../../../../components/state-component/StateComponents';
import ModalCustom from '../../../../components/modal/ModalCustom';
import { debouncedApiCall } from '../../../../utils/app.utils';
import { useLocation } from 'react-router-dom';

type Props = {
    is_setting?: boolean;
}

const ManageTags = ({ is_setting }: Props) => {
    const location = useLocation();
    const pathname = location.pathname
    const {
        page,
        pageLimit,
        data,
        sortBy,
        sortType,
        handleRequestSort,
        setPage,
        setPageLimit,
        headCells,
        totalItems,
        renderData,
        formState,
        showModal,
        setShowModal,
        handleSubmit,
        handleCloseModal,
        setFormState,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        checkPermit
    } = ManageState({ is_setting });
    return (
        <ContainerLayout
            title='จัดการแท็ก'
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: is_setting ? "จัดการเว็บไซต์" : "จัดการข้อมูลคอร์สออนไลน์",
                            name: is_setting ? "จัดการเว็บไซต์" : "จัดการข้อมูลคอร์สออนไลน์",
                            disabled_match: true,
                            pathName: ""
                        },
                        ...(is_setting ? [
                            {
                                key: "ตั้งค่า",
                                name: "ตั้งค่า",
                                disabled_match: true,
                                pathName: ""
                            },
                        ] : []),
                        {
                            key: "จัดการแท็ก",
                            name: "จัดการแท็ก",
                            pathName: pathname
                        },
                    ]}
                />
            }
            content={

                <div className='w-full'>
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 4
                                },
                                fieldProps: {
                                    placeholder: "ค้นหา ชื่อ",
                                    onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                }
                            },
                            {
                                seq: 2,
                                type: "DATE_RANGE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    onchange: handleChangeDateRange,
                                    value: date_range || [],
                                    onClear: handleClearDateRange,
                                    allowClear: true,
                                    placeholder: "ช่วงวันที่"
                                }
                            },
                            {
                                type: "COMPONENT",
                                seq: 3,
                                fieldProps: {
                                    element: <></>
                                },
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                }
                            },
                            {
                                seq: 4,
                                type: "BUTTON",
                                gridProps: {
                                    xs: 6,
                                    md: 2
                                },
                                hidden: !checkPermit.isCreated,
                                fieldProps: {
                                    justifyContent: "flex-end",
                                    buttonData: [
                                        {
                                            seq: 1,
                                            key: "ADD2",
                                            label: "เพิ่มแท็ก",
                                            buttonProps: {
                                                onClick: () => {
                                                    setShowModal("ADD")
                                                },
                                            },
                                            type: "ADD2"
                                        }
                                    ]
                                }
                            }
                        ]}
                    />
                    <section className='w-full mt-4'>
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>

                    {showModal !== "" && (
                        <ModalCustom
                            open
                            title={showModal === 'VIEW' ? 'รายละเอียดแท็ก' : 'เพิ่มแท็ก'}
                            subTitle='กรุณาระบุรายละเอียด'
                            onClose={handleCloseModal}
                            containerButton={{
                                onClose: () => handleCloseModal(),
                                onSubmit: () => handleSubmit(),
                                disabled_submit: !formState.tag_name,
                                hidden_submit: showModal === 'VIEW'
                            }}
                            component={
                                <div className='w-full'>
                                    <StateComponents
                                        disabledAllField={showModal === 'VIEW'}
                                        sxContainer={{ my: 2 }}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                gridProps: {
                                                    xs: 12
                                                },
                                                type: "TEXT_FIELD",
                                                fieldProps: {
                                                    onChange: (e) => setFormState((prev) => ({ ...prev, tag_name: e.target.value })),
                                                    value: formState.tag_name,
                                                    required: true,
                                                    placeholder: "ระบุ",
                                                    heading: "ชื่อแท็ก"
                                                }
                                            }
                                        ]}
                                    />
                                </div>
                            }
                        />
                    )}
                </div>
            }
        />
    )
}

export default ManageTags